import React, { useContext, useEffect, useState } from "react";
import { getMoengage } from "../../utils/moengage.js";
import { useLocation, useNavigate } from "react-router-dom";
import errorSVG from "../../assets/svg/EPL_think_svg/Error.svg";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { ErrorWrapper } from "./_styles/ErrorWrapper";
import { GetCustomerDetailsContext } from "../../App";
import sendRequest from "../../utils/sendRequest";
import { ERROR_LOGGING } from "../../Config";
import { encrypt } from "../../utils/crypto";
import { isStageLogin } from "../../shared/validations/StageLogin";
import { encryptedData } from "../../utils";

const Error = () => {
  const moengage = getMoengage();
  const navigate = useNavigate();
  const location = useLocation();
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const searchParams = new URLSearchParams(location.search);
  const [showShimmer, setShowShimmer] = useState(true);
  const [heading, setHeading] = useState("Technical Error!");
  const [retryCount, setRetryCount] = useState(0);
  const [subHeading, setSubHeading] = useState("");
  const [message, setMessage] = useState("");
  const source = location.pathname.split("/")[1];

  const errorLog = async () => {
    try {
      const formData = new FormData();
      const requestData = {
        api_name: sessionStorage.getItem("lastApiCall"),
      };
      formData.append("data", encryptedData(requestData));
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + source + ERROR_LOGGING,
        formData
      );
      console.log(response);
      // comment the code after fixed response from
      // console.log(response.response.error_title);
      // console.log(response.response.error_message);
      // console.log(response.response.retry_count);
      setRetryCount(response.response.retry_count);
      if (response.response.retry_count == 0) {
        setHeading(
          `Application Form No. - ${sessionStorage.getItem(
            "application_form_no"
          )})`
        );
        setMessage(
          "This is taking longer than usual. We will inform you in a few minutes."
        );
      } else {
        setHeading(response.response.error_title);
        setMessage(response.response.error_message);
      }
      setShowShimmer(false);
    } catch (error) {
      console.log(error);
    }
  };

  const api_list = [
    "saveBasicDetails",
    "bureauCall",
    "employmentCheck",
    "insertProfessionalDetails",
    "bureauCheckStatus",
    "dsCallSync",
    "dsCheckStatus",
    "callCEUpsell",
    "aa_wrapper",
    "perfios_retrieve_reports",
    "trigger_ce",
    "insertIpoDetails",
    "reviewIpoDetails",
    "insertSelfie",
    "liveliness",
    "checkCEStatus",
    "insertBankDetails",
    "okycCreateProfile",
    "ckycDataScience",
    "okycDataScience",
    "nishandeh_geotag",
    "faceMatch",
    "updateAddressDetails",
    "emandate",
    "getIfscBranch",
    "pennyDrop",
    "dsNameMatch",
    "getAllDocuments",
    "digitalSign",
    "updateDynamodb",
    "lmsLoanDisbursalAsyncA3S",
    "lmsLoanDisbursalAsyncFinnone",
    "locationNotInIndiaError",
    "locationNullError",
  ];

  useEffect(async () => {
    // console.log(sessionStorage.getItem("lastApiCall"));
    // console.log(customerDetails);
    // setCustomerDetails({
    //   ...customerDetails,
    // });

    isStageLogin(   
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );

    setTimeout(() => {
      moengage?.track_event("Technical_Error", {
        api_name: sessionStorage.getItem("lastApiCall"),
        journey_name: customerDetails.source,
      });
    }, 1000);

    if (parseInt(customerDetails?.Data?.retry_count) > 0) {
    } else {
      setHeading(
        `Application Form No. - ${sessionStorage.getItem(
          "application_form_no"
        )}`
      );
      setMessage(
        "This is taking longer than usual. We will inform you in a few minutes."
      );
    }
    if (
      customerDetails?.Data?.isError === "True" &&
      parseInt(customerDetails?.Data?.retry_count) > 0
    ) {
      setRetryCount(parseInt(customerDetails?.Data?.retry_count));
    }
    if (api_list.includes(sessionStorage.getItem("lastApiCall"))) {
      await errorLog();
      // console.log(customerDetails);
    }
  }, []);

  return (
    <>
      <ProgressBar showProgress={false} currentStep={0} />
      <AfterLoginLayoutWrapper>
        <ErrorWrapper className="first-child">
          <Title
            id="pageTitle"
            className="pageTitle"
            text={heading}
            visible={true}
            clickable={false}
            style={{
              fontSize: "24px",
              color: "#000",
            }}
          />
          <div
            style={{
              padding: "0px 0px",
              margin: "20px 0px 10px 0px",
              textAlign: "center",
            }}
          >
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={subHeading}
              style={{
                fontSize: "20px",
                color: "#000",
              }}
            />
          </div>
          {/* <div className="image">
            <img
              height={230}
              width={222}
              src={errorSVG}
              alt="Technical_Error"
            />
          </div> */}
          <div
            style={{
              padding: "0px 10px",
              margin: "10px",
              // backgroundColor: "red",
              textAlign: "center",
            }}
          >
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={message}
              style={{
                fontSize: "25px",
                color: "#000",
              }}
            />
          </div>
        </ErrorWrapper>
        <div className="bottomDiv only-btn">
          {/* <Button
            id="ProceedBtn"
            className="Btn ProceedBtn"
            disabled={false}
            onClick={() => {
              const updated = customerDetails;
              // updated.stage = "";
              updated.Data = null;
              updated.application_form_number = null;
              setCustomerDetails({
                ...updated,
              });

              var route = getRouteFromLoanStageService({
                source: source,
                stage: "",
              });
              if (searchParams.get("dsa_hash")) {
                const url = `${route}?dsa_hash=${searchParams.get("dsa_hash")}`;
                navigate(url, {
                  replace: true,
                });
              } else {
                const updated = customerDetails;
                updated.stage = "";
                setCustomerDetails({
                  ...updated,
                });
                navigate(`${route}`, {
                  replace: true,
                });
              }
            }}
            text={"Home"}
          /> */}
          {retryCount === 0 ? (
            <></>
          ) : (
            <>
              <Button
                id="ProceedBtn"
                className="Btn ProceedBtn"
                disabled={false}
                onClick={() => {
                  setShowShimmer(true);
                  var route = getRouteFromLoanStageService({
                    source: customerDetails.source,
                    stage: customerDetails.stage,
                  });
                  moengage?.track_event("Technical_Error_Retry_Button", {
                    retry_count: retryCount,
                    routed_to_page: route,
                    journey_name: customerDetails.source,
                  });
                  navigate(`${route}`, {
                    replace: true,
                    state: {
                      customerDetails: customerDetails,
                    },
                  });
                }}
                text={"Retry"}
              />
            </>
          )}
        </div>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default Error;
